import React from 'react';
import PropTypes from 'prop-types';
import A11yFontIcon from 'components/A11yFontIcon';
import DebouncedTextInput from 'components/DebouncedTextInput';
import './GamePageTitle.css';

const GamePageTitle = ({ onChangeFunction }) => (
  <div className="game-page-title-wrapper">
    <div className="content">
      <div className="title">Games</div>
      <div className="search-bar">
        <A11yFontIcon
          className="search-icon"
          icon="search"
          alt="Search Games"
        />
        <DebouncedTextInput
          className="game-search-bar"
          placeholder="Find a game"
          onChange={onChangeFunction}
          onClear={() => onChangeFunction('')}
        />
      </div>
    </div>
  </div>
);

GamePageTitle.propTypes = {
  onChangeFunction: PropTypes.func.isRequired
};

export default GamePageTitle;
